import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Invoice from "../pages/Sales/InvoiceList";
import Repair from "../pages/Repairs/Repairs";
import CustomerList from "../pages/Customers/CustomerList";

function CashierDashboard({ currentPage }) {
    return (
        <Section>
            {/* Pass currentPage as a prop to update navbar title */}
            <Navbar className="navbar" pageTitle={currentPage} />

            <div className="content">
                {/* Only render pages that cashiers should have access to */}
                {currentPage === "Invoice" && <Invoice />}
                {currentPage === "Repair" && <Repair />}
                {currentPage === "Customers" && <CustomerList />}

                {/* Default to Invoice if no specific page is selected */}
                {!["Invoice", "Repair", "Customers"].includes(currentPage) && <Invoice />}
            </div>
        </Section>
    );
}

export default CashierDashboard;

const Section = styled.section`
    display: flex;
    flex-direction: column;
    margin-left: 18vw; /* Ensures sidebar space */
    padding: 2rem;
    height: 100%;

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .navbar {
        position: fixed;
        top: 0;
        left: 18vw;
        width: calc(100% - 18vw);
        height: 4rem;
        background-color: white;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 999;
    }
`;